import { z } from 'zod'
import { atomWithSessionStorage } from '../useStorage/atomsWithStorages'
import { MFRM_UNIFY_CARE_TAB_NAME } from '../conventions'

export const careTabAtom = atomWithSessionStorage(MFRM_UNIFY_CARE_TAB_NAME, '/care/mycases', z.string())
